<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-container fluid>
      <!--<b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>COMISION PORTAL COMERCIAL</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>CT_01_PTI_Rechazo_EE</div>
        </b-col>
      </b-row>-->
      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col></b-col>

            <b-col
              align="right"
              v-if="$localStorageService.can('Admin_01_Portal_Comer_crear')"
              class="mt-1 mb-1"
            >
              <b-button
                v-b-tooltip.hover
                title="Crear Comisión"
                @click="agregar()"
                variant="outline-success"
                >Crear Comisión
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table
            id="Pendientes"
            thead-tr-class="columnas"
            :items="datosTabla"
            :fields="fields"
            :per-page="registrosPorPagina"
            :current-page="paginaActual"
            responsive="true"
            class="parrafos"
            fixed
          >
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                  v-if="$localStorageService.can('Admin_01_Portal_Comer_Edit')"
                  title="Modificar Comisión"
                  size="sm"
                  variant="outline-warning"
                  @click="modificar(row.item)"
                  ><em class="fa fa-pencil"></em
                ></b-button>
                <b-button
                  v-if="
                    !row.item.registroActivo &&
                    $localStorageService.can('Admin_01_Portal_Comer_Acti')
                  "
                  title="Activar Comisión"
                  variant="outline-danger"
                  size="sm"
                  @click="activarDesactivarComision(row.item)"
                  ><em class="fa fa-undo"></em
                ></b-button>
                <b-button
                  v-else-if="$localStorageService.can('Admin_01_Portal_Comer_Acti')"
                  title="Eliminar motivo"
                  variant="outline-danger"
                  size="sm"
                  @click="activarDesactivarComision(row.item)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </b-button-group>
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show
              >No hay datos</b-alert
            >
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
              v-if="datosTabla !== undefined && datosTabla.length > 10"
              align="center"
              v-model="paginaActual"
              :total-rows="datosTabla.length"
              :per-page="registrosPorPagina"
              aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
    </b-container>
    <b-modal v-model="show" :title="tituloModal" size="lg">
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group align="left">
                <label for="proveedor"
                  >Nombre Proveedor
                  <validacion />
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                    id="Proveedor"
                    name="proveedor"
                    placeholder="Nombre del proveedor"
                    v-model="$v.comision.proveedor.$model"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group align="left">
                <label for="comision"
                  >Comisión
                  <validacion />
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                    id="comision"
                    name="comision"
                    placeholder="Comision"
                   type="number"
                     v-model="$v.comision.comision.$model"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
                          <b-form-group align="left">
                <label for="meses"
                  >Meses
                  <validacion />
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                    id="meses"
                    name="meses"
                    placeholder="Meses"
                    type="number"
                    v-model="$v.comision.meses.$model"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button
          variant="outline-primary"
          :disabled="loaderAcciones"
          @click="guardar()"
        >
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button
          variant="outline-danger"
          :disabled="loaderAcciones"
          @click="cerrarModal()"
          >Cancelar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
export default {
  name: "comisionPortal",
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datosTabla: [],
      fields: [
        { key: "idComision", label: "ID", sortable: true },
        { key: "proveedor", label: "Proveedor", sortable: true },
        { key: "comision", label: "Comision", sortable: true },
        { key: "meses", label: "Meses", sortable: true },
        "Acciones",
      ],
      registrosPorPagina: 10,
      paginaActual: 0,
      filtro: {
        id: null,
        palabraClave: null,
        registroActivo: null,
      },
      tituloModal: "",
      loaderAcciones: false,
      show: false,
      comision: {
        idComision: null,
        proveedor: null,
        comision: null,
        meses: null,
        registroActivo: null,
      },
      loader: false,
      listaComisiones: [],
      contract : ''
    };
  },
validations: {
    comision: {
      proveedor:{required},
      comision:{required},
      meses:{required},
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerComisiones();
  },
  methods: {
    obtenerComisiones() {
      this.loader = true;
      this.$http
        .get(this.$api + "comision/listaComisionPortal")
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.datosTabla = respuesta.data.data;
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    activarDesactivarComision(item) {
      const mensaje = item.registroActivo
        ? "¿Está seguro de desactivar la comisión?"
        : "¿Está seguro de activar la comisión?";
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros = {
            idComision: item.idComision,
          }
          this.$http
            .post(
              this.$api +
                "comision/desactivarActivarComisionPortal",
                parametros
            )
            .then((respuesta) => {
              if (respuesta.data.data) {
                item.registroActivo = !item.registroActivo;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "La comisión se actualizó correctamente",
                });
              }
            });
        }
      });
    },
    agregar() {
      this.comision = {
        idComision: null,
        proveedor: null,
        comision: null,
        meses: null,
        registroActivo: null,
      };
      this.tituloModal = "Agregar comisión";
      this.show = true;
    },
    cerrarModal() {
      this.show = false;
    },
    modificar(item) {
      this.comision = item;
      this.tituloModal = 'Modificar comisión';
      this.show = true;
    },
  guardar(){
     this.$v.comision.$touch();
      if (this.$v.comision.$anyError) {
        return;
      }
      if (!this.$v.comision.$invalid) {
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'comision/guardarComisionPortal', this.comision).then(respuesta => {
              if (respuesta.data.data) {
                this.obtenerComisiones();
                this.show = false;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "La comisión se guardó correctamente",
                });
              }
            }
        ).finally(() => {
              this.loaderAcciones = false;
            }
        )
      }
    }
  },
};
</script>

<style>
</style>